/* ============================================================
   LOZLIN 滚动渐入效果 (Reveal on Scroll) - 增强版
   使用 IntersectionObserver API 实现高性能滚动动画
   类似 EZARC 的上滑渐入效果
   支持：首页、产品列表页、产品详情页、其他页面
   ============================================================ */

(function() {
  'use strict';

  // 检查是否支持 IntersectionObserver
  var supportsIntersectionObserver = 'IntersectionObserver' in window;

  // 配置选项
  var DEFAULT_OPTIONS = {
    threshold: 0.1,
    rootMargin: '0px 0px -80px 0px',
    once: true
  };

  // 获取当前页面模板
  function getTemplate() {
    var bodyClass = document.body.className;
    if (bodyClass.indexOf('template-index') !== -1) return 'index';
    if (bodyClass.indexOf('template-collection') !== -1) return 'collection';
    if (bodyClass.indexOf('template-product') !== -1) return 'product';
    if (bodyClass.indexOf('template-page') !== -1) return 'page';
    return 'other';
  }

  // 自动为页面元素分配动画效果 - 增强版
  function autoAssignRevealEffects() {
    var template = getTemplate();

    // 通用选择器 - 适用于所有页面
    var selectors = [];

    if (template === 'index') {
      // 首页 - 更丰富的动画
      selectors = [
        // 轮播图区域
        '.custom-slider-section .custom-slide-item',
        '.custom-slider-section h1',
        '.custom-slider-section h2',
        '.custom-slider-section .slide-heading',
        '.custom-slider-section .slide-description',
        '.custom-slider-section .slide-tagline',

        // 产品网格
        '.product-grid .grid__item',
        '.custom-home-products h2',
        '.custom-home-products .grid__item',

        // 特色分类
        '.featured-categories h2',
        '.featured-categories .grid__item',

        // 视频区域
        '.lozlin-video',
        '.lozlin-video h2',
        '.lozlin-video p',

        // 评价/推荐区域
        '.testimonials-section',
        '.testimonials-section h2',
        '.testimonials-section .grid__item',

        // 特色内容块
        '.featured-content-blocks',
        '.featured-content-blocks .grid__item',
        '.featured-content-blocks h2',
        '.featured-content-blocks h3',

        // 多列表格区域
        'multicolumn h2',
        'multicolumn h3',
        'multicolumn .grid__item',

        // 富文本区块
        '.rich-text__blocks',
        '.rich-text__blocks h1',
        '.rich-text__blocks h2',
        '.rich-text__blocks p',

        // 博客文章
        '.lozlin-blog-posts h2',
        '.lozlin-blog-posts .grid__item',

        // Feature 区块
        '.feature-row',
        '.feature-row .grid__item',

        // 通用 section 标题和内容
        'section h1',
        'section h2',
        'section h3',
        'section .rte',
        'section .rte p',
        'section .grid__item',
        'section > .page-width',
        'section > .page-width > *:first-child',

        // 图片元素
        '.rte img',
        '.section img'
      ];
    } else if (template === 'collection') {
      // 产品列表页 (collection)
      selectors = [
        // 页面标题和描述
        '.collection-hero__title',
        '.collection-hero__description',
        '.collection-header h1',
        '.collection-header p',

        // 三级菜单区域
        '.lozlin-collection-advanced .lozlin-sub-collections-grid',
        '.lozlin-collection-advanced .lozlin-sub-collection-item',

        // 筛选标签
        '.lozlin-collection-advanced .lozlin-active-filters',
        '.lozlin-collection-advanced .lozlin-active-filter',

        // 左侧筛选栏
        '.collection__facets',
        '.collection-facets',
        '.facets-container',
        '.collection__facets h2',
        '.collection__facets h3',

        // 产品卡片
        '.lozlin-collection-advanced .lozlin-product-card',
        '.collection-grid .grid__item',
        '.product-grid .grid__item',

        // 产品列表内容
        '.collection .grid__item',
        '.product-card',

        // 通用 section 元素
        'section h2',
        'section h3',
        'section .rte p',
        'section .grid__item'
      ];
    } else if (template === 'product') {
      // 产品详情页
      selectors = [
        // 产品图片和信息
        '.product-section',
        '.product__media-wrapper',
        '.product__info-wrapper',
        '.product__title',
        '.product__description',
        '.product__price',

        // 产品推荐
        '.product-recommendations',
        '.product-recommendations h2',
        '.product-recommendations .grid__item',

        // 相关产品
        '.related-products',
        '.related-products .grid__item',

        // 通用元素
        'section h1',
        'section h2',
        'section h3',
        'section .rte p'
      ];
    } else if (template === 'page') {
      // 其他页面（如 about, why-lozlin 等）
      selectors = [
        // 页面主标题
        '.main-page-title',
        '.section-header h1',

        // 页面内容
        '.page-width .rte',
        '.page-width .rte h1',
        '.page-width .rte h2',
        '.page-width .rte h3',
        '.page-width .rte p',
        '.page-width .rte img',

        // 特殊页面元素
        '.lozlin-why',
        '.lozlin-why h1',
        '.lozlin-why h2',
        '.lozlin-why p',
        '.lozlin-why__container > *',
        '.lozlin-about-section',
        '.lozlin-about-section > *',

        // 通用元素
        'section > *',
        'section h1',
        'section h2',
        'section h3',
        'section .grid__item'
      ];
    } else {
      // 其他页面 - 基础动画
      selectors = [
        'section h1',
        'section h2',
        'section h3',
        'section .rte',
        'section .grid__item',
        'section > .page-width'
      ];
    }

    // 处理元素
    var processedElements = new Set();
    var delayCounter = 0;

    selectors.forEach(function(selector) {
      try {
        var elements = document.querySelectorAll(selector);

        elements.forEach(function(el, index) {
          // 避免重复处理
          if (processedElements.has(el)) return;
          processedElements.add(el);

          // 确保元素还没有动画属性
          if (el.hasAttribute('data-reveal-on-scroll')) return;
          if (el.classList.contains('reveal-on-scroll')) return;

          // 跳过一些不该有动画的元素
          if (el.offsetParent === null) return; // 隐藏元素

          // 添加渐入类
          el.classList.add('reveal-on-scroll');

          // 根据元素类型和位置分配延迟
          var parentGrid = el.closest('.grid');
          if (parentGrid && (el.classList.contains('grid__item') || el.classList.contains('lozlin-product-card'))) {
            // 对于网格项目，分配不同延迟，使错落出现
            var gridChildren = parentGrid.querySelectorAll(':scope > *');
            var gridIndex = Array.prototype.indexOf.call(gridChildren, el);
            if (gridIndex >= 0) {
              var delay = (gridIndex % 4) + 1;
              el.setAttribute('data-reveal-delay', String(delay));
            }
          } else if (el.classList.contains('lozlin-sub-collection-item')) {
            // 三级菜单圆形图标
            var iconIndex = Array.prototype.indexOf.call(el.parentNode.children, el);
            if (iconIndex >= 0) {
              el.setAttribute('data-reveal-delay', String((iconIndex % 6) + 1));
              el.setAttribute('data-reveal-effect', 'zoom');
            }
          } else if (el.tagName === 'H1' || el.tagName === 'H2' || el.tagName === 'H3') {
            // 标题类元素 - 更快显示
            delayCounter++;
            if (delayCounter % 2 === 0) {
              el.setAttribute('data-reveal-delay', '1');
            }
          } else if (el.classList.contains('product-card') || el.classList.contains('lozlin-product-card')) {
            // 产品卡片 - 更好的延迟
            delayCounter++;
            var cardDelay = (delayCounter % 4) + 1;
            el.setAttribute('data-reveal-delay', String(cardDelay));
          } else {
            // 其他元素 - 适度延迟
            delayCounter++;
            if (delayCounter % 2 !== 0) {
              el.setAttribute('data-reveal-delay', String((delayCounter % 3) + 1));
            }
          }

          // 根据元素位置分配不同的动画方向（仅限桌面端）
          if (window.innerWidth >= 750) {
            var rect = el.getBoundingClientRect();
            var centerX = rect.left + rect.width / 2;
            var viewportCenter = window.innerWidth / 2;

            if (centerX < viewportCenter * 0.8) {
              // 左侧元素从左滑入
              el.setAttribute('data-reveal-direction', 'left');
            } else if (centerX > viewportCenter * 1.2) {
              // 右侧元素从右滑入
              el.setAttribute('data-reveal-direction', 'right');
            }
          }
        });
      } catch (e) {
        // 忽略无效选择器的错误
      }
    });
  }

  // 初始化 IntersectionObserver
  function initRevealOnScroll() {
    // 首先自动为页面元素分配动画效果
    try {
      autoAssignRevealEffects();
    } catch (e) {
      console.warn('Error in autoAssignRevealEffects:', e);
    }

    // 获取所有需要渐入的元素
    var revealElements = document.querySelectorAll('[data-reveal-on-scroll], .reveal-on-scroll');

    if (revealElements.length === 0) {
      return;
    }

    // 如果不支持 IntersectionObserver，直接显示所有元素
    if (!supportsIntersectionObserver) {
      revealElements.forEach(function(el) {
        el.classList.add('is-visible');
      });
      return;
    }

    // 创建 IntersectionObserver
    var observer = new IntersectionObserver(function(entries, obs) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          // 元素进入视口，添加可见类
          var target = entry.target;

          // 检查是否有自定义延迟
          var customDelay = target.getAttribute('data-reveal-delay');
          if (customDelay) {
            var delayMs = parseInt(customDelay, 10) * 100;
            setTimeout(function() {
              target.classList.add('is-visible');
            }, delayMs);
          } else {
            target.classList.add('is-visible');
          }

          // 如果设置为只触发一次，停止观察
          if (DEFAULT_OPTIONS.once) {
            obs.unobserve(target);
          }
        } else if (!DEFAULT_OPTIONS.once) {
          // 元素离开视口（如果不是一次性的）
          entry.target.classList.remove('is-visible');
        }
      });
    }, {
      threshold: DEFAULT_OPTIONS.threshold,
      rootMargin: DEFAULT_OPTIONS.rootMargin
    });

    // 观察所有元素
    revealElements.forEach(function(el) {
      observer.observe(el);
    });

    // 存储 observer 以便后续使用
    window.__lozlinRevealObserver = observer;
  }

  // 处理 Ajax 动态加载的 section（Shopify 主题编辑器）
  function handleSectionLoad() {
    document.addEventListener('shopify:section:load', function() {
      // 延迟执行以确保 DOM 已更新
      setTimeout(function() {
        if (window.__lozlinRevealObserver) {
          window.__lozlinRevealObserver.disconnect();
        }
        initRevealOnScroll();
      }, 150);
    });
  }

  // 初始化 - 等待页面准备就绪
  function initializeWhenReady() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initRevealOnScroll();
        handleSectionLoad();
      });
    } else {
      initRevealOnScroll();
      handleSectionLoad();
    }

    // 也在 window load 时初始化（确保所有资源就绪）
    window.addEventListener('load', function() {
      // 检查是否有还未显示的元素（可能在首屏）
      var revealElements = document.querySelectorAll('[data-reveal-on-scroll]:not(.is-visible), .reveal-on-scroll:not(.is-visible)');

      // 对于视口内的元素，立即显示
      revealElements.forEach(function(el, index) {
        var rect = el.getBoundingClientRect();
        var isInViewport = (
          rect.top < window.innerHeight * 0.95 &&
          rect.bottom > 0
        );
        if (isInViewport) {
          // 延迟一点，让用户看到动画
          var initialDelay = el.getAttribute('data-reveal-delay');
          var delay = initialDelay ? (parseInt(initialDelay, 10) * 100) + 100 : 100;
          setTimeout(function() {
            el.classList.add('is-visible');
          }, delay);
        }
      });
    });
  }

  // 开始初始化
  initializeWhenReady();

  // 暴露给其他脚本使用的 API
  window.LozlinRevealOnScroll = {
    init: initRevealOnScroll,
    refresh: function() {
      if (window.__lozlinRevealObserver) {
        window.__lozlinRevealObserver.disconnect();
      }
      initRevealOnScroll();
    },
    reveal: function(element) {
      if (element) {
        element.classList.add('reveal-on-scroll');
        if (window.__lozlinRevealObserver) {
          window.__lozlinRevealObserver.observe(element);
        }
      }
    }
  };

})();
